import { render, staticRenderFns } from "./MainStage.vue?vue&type=template&id=ba86538e&scoped=true&lang=pug"
import script from "./MainStage.vue?vue&type=script&lang=ts"
export * from "./MainStage.vue?vue&type=script&lang=ts"
import style0 from "./MainStage.vue?vue&type=style&index=0&id=ba86538e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba86538e",
  null
  
)

export default component.exports